import { Link, Stack } from "@mui/material";
import ClassNames from "../util/ClassNames";
import Time from "../util/Time";
import Breakable from "./Breakable";
import style from "./ReservationSummary.module.css";
import Space from "./Space";
import { ColorHexCodes } from "../util/Color";
import { StyledText } from "./StyledText";
import { Course, Store } from "../api/ApiData";

export default function ReservationSummary({ data }: { data: { store: Store; nominated_staff_name: string | undefined; course: Course; date: number; name: string; phone: string; mail: string; request: string } }) {
  const addresses = [data.store.prefecture, data.store.address_1, data.store.address_2];
  const ds = new Time(data.date).DateStrings();
  return (
    <Stack style={{ gap: 10 }}>
      <StyledText textStyle="Bold">ご予約情報</StyledText>
      <InfoItem label="店舗" value={data.store.name} />
      <InfoItem label="スタッフ" value={data.nominated_staff_name ?? "指名なし"} hide={!data.store.nomination_enabled} />
      <InfoItem label="メニュー" value={data.course.name} />
      <InfoItem label="日時" value={`${ds.year}年${ds.month}月${ds.date}(${ds.day}) ${ds.hour}時${ds.minute}分 (${data.course.duration / Time.AMinute}分間)`} />
      <div style={{ height: 1, width: "100%", background: `#${ColorHexCodes.MainColorGreen}` }} />
      <div>
        <StyledText textStyle="Bold">店舗情報</StyledText>
        <div className={ClassNames(style.mapContainer)}>
          <Stack style={{ flexGrow: 2 }}>
            <Space h={15} />
            <InfoItem label="店舗" value={data.store.name} />
            <Space h={15} />
            <InfoItem label="TEL" value={data.store.phone} />
            <Space h={15} />
            <Stack direction={"row"}>
              <Stack style={{ width: 90 }}>
                <StyledText>住所</StyledText>
              </Stack>
              <Stack style={{ width: 0, flexGrow: 1 }}>
                <StyledText>{`〒${data.store.post_code}`}</StyledText>
                <Breakable texts={addresses} style={{ overflowWrap: "anywhere" }} />
              </Stack>
            </Stack>
            <Space h={15} />
            <Stack direction={"row"}>
              <Stack style={{ width: 90 }}>
                <StyledText>HP</StyledText>
              </Stack>
              <Link style={{ width: 0, flexGrow: 1, wordBreak: "break-all" }} href={data.store.homepage}>
                {data.store.homepage}
              </Link>
            </Stack>
          </Stack>
          <iframe title="map" src={`https://maps.google.co.jp/maps?q=` + addresses.join() + `&output=embed&t=m&z=16&hl=ja`} style={{ flexGrow: 2, minWidth: "300px", minHeight: "300px", border: "none" }} />
        </div>
      </div>
      <div style={{ height: 1, width: "100%", background: `#${ColorHexCodes.MainColorGreen}` }} />
      <StyledText textStyle="Bold">お客様情報</StyledText>
      <InfoItem label="お名前" value={data.name} />
      <InfoItem label="TEL" value={data.phone} />
      <InfoItem label="E-MAIL" value={data.mail} />
      <InfoItem label="ご要望" value={data.request} />
    </Stack>
  );
}

function InfoItem({ label, value, hide }: { label: string; value: string; hide?: boolean }) {
  if (hide) {
    return <></>;
  }
  return (
    <Stack direction={"row"}>
      <Stack style={{ width: 90 }}>
        <StyledText>{label}</StyledText>
      </Stack>
      <Stack style={{ width: 0, flexGrow: 1 }}>
        <StyledText>{value}</StyledText>
      </Stack>
    </Stack>
  );
}
